import React from 'react';
import { IconProps } from './typing';

const Financial = ({
  iconSize = 24,
  background = 'none',
  color = 'currentColor',
}: IconProps) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox={`0 0 ${iconSize} ${iconSize}`}
    fill={background}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.984 7.926V17.067C22.984 18.6802 21.6762 19.988 20.063 19.988H3.922C2.30862 19.988 1.00055 18.6804 1 17.067V7.926C0.998941 7.15035 1.30632 6.4061 1.85442 5.85725C2.40252 5.3084 3.14635 5 3.922 5H20.059C20.8352 4.9992 21.5798 5.30725 22.1285 5.85619C22.6773 6.40512 22.9851 7.14983 22.984 7.926ZM8.134 9C8.60344 9 8.984 9.38056 8.984 9.85V12.15C8.984 12.6194 8.60344 13 8.134 13H5.834C5.36456 13 4.984 12.6194 4.984 12.15V9.85C4.984 9.38056 5.36456 9 5.834 9H8.134ZM20.063 6.334C20.9416 6.3351 21.6535 7.04738 21.654 7.926L21.65 17.067C21.6489 17.9452 20.9372 18.6569 20.059 18.658H3.922C3.04338 18.6575 2.33111 17.9456 2.33 17.067V7.926C2.3311 7.04722 3.04322 6.3351 3.922 6.334H20.063Z"
      fill={color}
    />
  </svg>
);

export default Financial;
